import * as React from "react";
import type { SVGProps } from "react";
const SvgIconCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 12 12"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m11.08 1.2-.16.07-3.35 4.08L4.2 9.46l-.11.1c-.06.03-.08.03-.17.03s-.12 0-.17-.03c-.03-.01-.63-.53-1.36-1.17-1-.88-1.32-1.15-1.38-1.18-.07-.04-.09-.04-.19-.04-.09 0-.12 0-.17.03q-.14.08-.21.21C.4 7.47.4 7.5.4 7.6c0 .1 0 .12.04.19s.05.09 1.33 1.21l1.38 1.2c.1.08.28.18.41.22q.46.13.9-.08c.18-.09.3-.19.48-.41L8.3 5.8c1.88-2.3 3.23-3.95 3.25-4 .03-.06.04-.08.04-.17s0-.12-.04-.2q-.1-.18-.32-.23z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconCheck;
